import React, { createContext, useState, useEffect, useMemo, useCallback } from "react";
import { log } from '../Assets/enviorement';

// Create the CartContext
export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]); // Cart state
  const [totalPrice, setTotalPrice] = useState(0); // Total price state

  // Function to add a product to the cart
  const addToCart = useCallback((product) => {
    setCart((prevCart) => {
      const updatedCart = [...prevCart, product];
     if (process.env.NODE_ENV === 'development') {
       console.log("Cart Updated:", updatedCart);
     }

      return updatedCart;
    });
  }, []);

  // Function to calculate total price
  const calculateTotal = () => {
    const total = cart.reduce((acc, item) => {
      const itemPrice = item.price;
      const itemQuantity = parseInt(item.quantity) || 1; // Default quantity to 1 if invalid
      return acc + itemPrice * itemQuantity;
    }, 0);
    return total;
  };

  // Update total price whenever the cart changes
  useEffect(() => {
    const newTotal = calculateTotal();
    setTotalPrice(newTotal); // Set the total price in state
    log("New Total Price:", newTotal); // Log the new total price
  }, [cart]); // Re-run whenever the cart changes
  const clearCart = useCallback(() => {
    setCart([]); // Reset cart to an empty array
    log("Cart Cleared");
  }, []);

  const value = useMemo(() => ({
    cart,
    setCart,
    addToCart,
    totalPrice,
    clearCart
  }), [cart, addToCart, totalPrice, clearCart]);

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
};
